import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestCaruse } from "../../entity/EntityRequestCaruse";

export class DtoRequestCarusesGetRes extends EntityRequestCaruse {
  public items: EntityRequestCaruse[]  = [];
}
